import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../GlobalModules/Login/Actions/LoginAction';
import { Tabs, Tab } from 'react-bootstrap';

import Utility from '../../../../GlobalModules/Utility/Utility'
import ModalGlobal from '../../../../GlobalModules/Utility/Components/ModalGlobal'
import ConfirmationAlert from '../../../../GlobalModules/Utility/Components/ConfirmationAlert'
import '../../../../GlobalModules/Utility/Public/css/common.scss';
// import '../../../../GlobalModules/Utility/Public/css/commonresponsive.scss';
import '../Styles/BillPostingSettings.scss';
import { withRouter } from 'react-router-dom';
// import Role from '../Components/RoleTab/Role';
// import RoomFacility from '../Components/RoomFacilityTab/RoomFacility';
// import Subscription from '../Components/SubscriptionTab/Subscription';
// import BankDetails from '../Components/BankDetailsTab/BankDetails';
// import BookingRules from '../Components/RulesTab/BookingRules';
// import CancellationRules from '../Components/RulesTab/CancellationRules';
// import Amenities from '../Components/Amenities/Amenities';
import AppSettings from '../Components/AppSettings/AppSettings';
import VariantOptionsTab from '../Components/VariantOptions/VariantOptionsTab';
import MeasurementUnitsTab from '../Components/MeasurementUnits/MeasurementUnitsTab';
// import Tax from '../Components/TaxTab/Tax';
import EventEmitter from '../../../../GlobalModules/Utility/Components/EventEmitter';

class SettingsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTabName: localStorage.getItem("selectedTabName") && localStorage.getItem("selectedTabName") != "" ? localStorage.getItem("selectedTabName") : this.props.userCredentials.user_details.user_type == "app_admin" ? "room_facility" : "app_settings",
            tabcontainerspace: "",
            tabchangeParent: false,
            tabChangeConfirmModal: false,
            tempTabName: ""

        }
    }
    componentDidMount() {
        this.props.handleActiveLink("settings_module", "");
        this.permissionWiseTabSelected();

        this.listener = EventEmitter.addListener("sendMessage", (message, id = "") => {
            if (message == 'branch') {
                this.setState({
                    selectedTabName: 'branch'
                }, () => {
                    this.props.history.push(`/${localStorage.getItem('i18nextLng')}/home/branch`)
                })
            }
        })
    }


    componentDidUpdate(prevProps, prevState) {
        let splitUrl = this.props.history.location.pathname.split('/');
        if (this.props.history.location.pathname != prevProps.location.pathname) {
            if (!Number.isNaN(Number(splitUrl[splitUrl.length - 1]))) {
                this.setState({ selectedTabName: splitUrl[splitUrl.length - 2] })
            } else {
                this.setState({ selectedTabName: splitUrl[splitUrl.length - 1] })
            }
        }
    }

    setTabConatinerSpaceClass = (className) => {
        this.setState({
            tabcontainerspace: className
        })

    }

    detectChangesIndividualTab = (value = false) => {
        this.setState({
            tabchangeParent: value
        })

    }


    openTabChangeConfirmModal = () => {
        this.setState({
            tabChangeConfirmModal: true
        })
    }
    tabChangeConfirmModalHide = () => {
        this.setState({
            tabChangeConfirmModal: false,
            tempTabName: ""
        })
    }

    //tab select onchange fn
    handelSelectTab = (tabName) => {
        if (this.state.tabchangeParent == true) {
            let saveData = localStorage.setItem("selectedTabName", tabName);
            this.setState({
                tempTabName: tabName
            }, () => {
                this.openTabChangeConfirmModal()
                this.confirmTabChange()
            })
        } else {
            let saveData = localStorage.setItem("selectedTabName", tabName);
            this.setState({
                selectedTabName: tabName
            }, () => {
                // Handle special routing for bill posting settings
                // if (tabName === 'bill_posting_settings') {
                //     this.props.history.push(`/${localStorage.getItem('i18nextLng')}/settings/bill_posting_setting`);
                // } else {
                //     this.props.history.push(`/${localStorage.getItem('i18nextLng')}/settings/${this.state.selectedTabName}`);
                // }
            })
        }
    }
    confirmTabChange = () => {
        this.setState({
            selectedTabName: this.state.tempTabName
        }, () => {
            this.cancelTabChange()
            this.setState({
                tabchangeParent: false
            })
        })
    }
    cancelTabChange = () => {
        this.tabChangeConfirmModalHide()
    }

    permissionWiseTabSelected = () => {
        const { roleWisePermission, userCredentials } = this.props;
        
        if (this.props.match.params.type) {
            this.setState({
                selectedTabName: this.props.match.params.type
            })
        } else {
            let tab_order = ["app_settings", "variant_options", "measurement_units", "role", "booking_rules", "cancellation_rules", "tax", "amenities"];
            if (userCredentials?.user_details?.user_type == "app_admin") {
                tab_order = ["room_facility", "subscription", "bank_details"]
            }
            let selectedTabList = tab_order.map((e) => {
                if (Object.keys(Utility.getRoleObjectByEventKey(e)).length > 0) {
                    return e;
                } else {
                    return "";
                }
            })
            let selectedTab = selectedTabList.filter(function (el) {
                return el != "";
            });
            this.setState({
                selectedTabName: selectedTab.length > 0 ? selectedTab[0] : ""
            })
        }
    }

    validationPermission = (eventKey) => {
        const { t, roleWisePermission } = this.props;
        let valid = false;
        if (roleWisePermission.hasOwnProperty(eventKey) && roleWisePermission[eventKey].read_write_permission != "") {
            valid = true;
        }
        return valid
    }

    tabUi = () => {
        const { t, roleWisePermission, userCredentials } = this.props;
        let arryHash = roleWisePermission;
        let arry = [];
       
        if (userCredentials?.user_details.user_type == "app_admin"){
            arry.push(
                <Tab eventKey="app_settings" title="App Settings" key={0}>
                    {this.state.selectedTabName == 'app_settings' ?
                        <AppSettings detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            );
        }
        if (userCredentials?.user_details?.is_subscribed && userCredentials?.user_details.user_type == "admin" && Utility.getRoleObjectBySubEventKey('settings', 'variant_options').length > 0 || userCredentials?.user_details?.is_subscribed && userCredentials.user_details.user_type == "staff" && Utility.getRoleObjectBySubEventKey('settings', 'variant_options')?.length > 0) {
            // Add Variant Options Tab
            arry.push(
                <Tab eventKey="variant_options" title="Variant Options" key={1}>
                    {this.state.selectedTabName == 'variant_options' ?
                        <VariantOptionsTab detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            );
        }
        if (userCredentials?.user_details?.is_subscribed && userCredentials?.user_details.user_type == "admin" && Utility.getRoleObjectBySubEventKey('settings', 'measurement_units').length > 0 || userCredentials?.user_details?.is_subscribed && userCredentials.user_details.user_type == "staff" && Utility.getRoleObjectBySubEventKey('settings', 'measurement_units')?.length > 0) {
            // Add Measurement Units Tab
            arry.push(
                <Tab eventKey="measurement_units" title="Measurement Units" key={2}>
                    {this.state.selectedTabName == 'measurement_units' ?
                        <MeasurementUnitsTab detectChangesIndividualTab={this.detectChangesIndividualTab} /> : null}
                </Tab>
            );
        }
        
        // Bill Posting Settings is now a standalone page, not a tab
        
        return arry;
    }

    render() {
        const { t } = this.props;
        const { tabcontainerspace } = this.state;
        return (
            <div className={`${tabcontainerspace} homepagecontainer connectheader`} >
                <Tabs
                    id="homepagetabs"
                    activeKey={this.state.selectedTabName}
                    className="tabsmainbox"
                    onSelect={this.handelSelectTab}

                >
                    {this.tabUi()}
                </Tabs>
                <ModalGlobal
                    show={this.state.tabChangeConfirmModal}
                    onHide={this.tabChangeConfirmModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title=""
                    footer={false}
                    body={
                        <ConfirmationAlert
                            BodyFirstContent='navigateConfirmation'
                            BodySecondContent=""
                            BodyThirdContent=""
                            confirmationButtonContent='confirm'
                            cancelButtonContent='cancel'
                            deleteConfirmButton={this.confirmTabChange}
                            deleteCancleButton={this.cancelTabChange}
                        />
                    }
                />
            </div >
        );
    }
}




const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        access_token: globalState.mainReducerData.access_token,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        websocket: globalState.mainReducerData.websocket
    };
}


export default connect(mapStateToProps, { handleActiveLink, setUserCredentials })(withRouter(SettingsPage));
